import request from "@/utils/request";
// 参数设置与同步
export function sbCsList(params) {
  return request({
    url: "/system/cs/sbCsList",
    method: "post",
    data: params,
  });
}

// 设备参数详情
export function querySbCs(sbid) {
  return request({
    url: `/system/cs/querySbCs/${sbid}`,
    method: "get",
  });
}

// 设备参数同步
export function parameterSynchronization(params) {
  return request({
    url: `/system/cs/parameterSynchronization`,
    method: "POST",
    data: params,
  });
}

// 打码机重置
export function printerReset(sbid) {
  return request({
    url: `/system/cs/printerReset/${sbid}`,
    method: "GET",
  });
}

// 设备指令下发
export function commandIssued(params) {
  return request({
    url: `/system/cs/commandIssued`,
    method: "post",
    data: params,
  });
}

// 设备历史参数列表
export function sbLscsList(params) {
  return request({
    url: `/system/lscs/sbLscsList`,
    method: "POST",
    data: params,
  });
}

// 打码机重置
export function lscs(sbid) {
  return request({
    url: `/system/lscs/${sbid}`,
    method: "GET",
  });
}

// c端 电子秤型号列表
export function euipmentQueryDzc() {
  return request({
    url: `/system/dzc/euipmentQueryDzc`,
    method: "GET",
  });
}
